import { _ } from "../../core/polyglot/polyglot.js";
import abstractCustomInvoiceReportDocument from "./abstractCustomInvoiceReportDocument.js";

/**
 * `agedReceivablesReportDocument` is an accounting document responsible
 * for displaying invoice groups values based on due dates.
 */
export default abstractCustomInvoiceReportDocument.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);

		that.title = _("Aged receivables");
	};

	my.getReportId = function () {
		return "AgedReceivablesPerCustomer";
	};

	my.getFirstColumnName = function () {
		return _("Customer");
	};

	my.getHelpMessage = function () {
		return _(
			"This report distinguishing open accounts receivable based on the length of time an invoice has been outstanding.",
		);
	};
});
